import { ProtectedResourceScopes } from '@azure/msal-angular';
import { environment } from 'src/environment/environment';
import { apiAccessRolesProtectedResources } from '../../modules/access-roles/services/access-roles-api.service';
import { apiBaselineDocumentsProtectedResources } from '../../modules/baseline-documents/services/baseline-documents-api.service';
import { apiClausesProtectedResources } from '../../modules/clauses/services/clauses-api.service';
import { apiPartiesProtectedResources } from '../../modules/counterparties/services/parties-api.service';
import { apiDocumentTypesProtectedResources } from '../../modules/doc-types/services/document-types-api.service';
import { apiDocumentGenerationProtectedResources } from '../../modules/document-generation/services/document-generation-api.service';
import { apiDocumentSignatureProtectedResources } from '../../modules/document-signature/services/document-signature-api.service';
import { apiDocumentProcessingProtectedResources } from '../../modules/documents/services/document-processing-api.service';
import { apiDocumentsProtectedResources } from '../../modules/documents/services/documents-api.service';
import { apiGroupsProtectedResources } from '../../modules/groups/services/groups-api.service';
import { apiUserProtectedResources } from '../../modules/login/services/user-api.service';
import { apiExtractionMetadataProtectedResources } from '../../modules/metadata/services/metadata-api.service';
import { apiPermissionsProtectedResources } from '../../modules/permissions/services/permissions-api.service';
import { apiPlaybooksProtectedResources } from '../../modules/playbooks/services/playbooks-api.service';
import { apiKeyQuestionsProtectedResources } from '../../modules/questions/services/questions-api.service';
import { apiRecipientsProtectedResources } from '../../modules/recipients/services/recipients-api.service';
import { apiTeamRolesProtectedResources } from '../../modules/team-roles/services/team-roles-api.service';
import { apiUsersProtectedResources } from '../../modules/users/services/users-api.service';
import { apiVarianceAnalysisProtectedResources } from '../../modules/workspaces/services/variance-analysis-api.service';
import { apiWorkspacesProtectedResources } from '../../modules/workspaces/services/workspaces-api.service';
import { apiConfigurationProtectedResources } from '../../shared/services/configuration-api.service';
import { apiDocumentStatusesProtectedResources } from '../../shared/services/document-statuses-api.service';
import { apiFileUploadProtectedResources } from '../../shared/services/file-upload.api-service';
import { apiLanguagesProtectedResources } from '../../shared/services/languages-api.service';
import { apiPositionsProtectedResources } from '../../shared/services/positions-api.service';
import { apiReportingProtectedResources } from '../../shared/services/reporting-api.service';

export function getMsalProtectedResourceMap(): Map<
  string,
  Array<string | ProtectedResourceScopes> | null
> {
  const protectedResourceMap = new Map<string, Array<string | ProtectedResourceScopes> | null>();

  protectedResourceMap.set(
    environment.protectedResources.apiUser.endpoint,
    apiUserProtectedResources,
  );
  protectedResourceMap.set(
    environment.protectedResources.apiDocuments.endpoint,
    apiDocumentsProtectedResources,
  );
  protectedResourceMap.set(
    environment.protectedResources.apiDocumentProcessing.endpoint,
    apiDocumentProcessingProtectedResources,
  );
  protectedResourceMap.set(
    environment.protectedResources.apiDocumentGeneration.endpoint,
    apiDocumentGenerationProtectedResources,
  );
  protectedResourceMap.set(
    environment.protectedResources.apiDocumentSignature.endpoint,
    apiDocumentSignatureProtectedResources,
  );
  protectedResourceMap.set(
    environment.protectedResources.apiRecipients.endpoint,
    apiRecipientsProtectedResources,
  );
  protectedResourceMap.set(
    environment.protectedResources.apiBaselineDocuments.endpoint,
    apiBaselineDocumentsProtectedResources,
  );
  protectedResourceMap.set(
    environment.protectedResources.apiDocumentTypes.endpoint,
    apiDocumentTypesProtectedResources,
  );
  protectedResourceMap.set(
    environment.protectedResources.apiPositions.endpoint,
    apiPositionsProtectedResources,
  );
  protectedResourceMap.set(
    environment.protectedResources.apiParties.endpoint,
    apiPartiesProtectedResources,
  );
  protectedResourceMap.set(
    environment.protectedResources.apiWorkspaces.endpoint,
    apiWorkspacesProtectedResources,
  );
  protectedResourceMap.set(
    environment.protectedResources.apiVarianceAnalysis.endpoint,
    apiVarianceAnalysisProtectedResources,
  );
  protectedResourceMap.set(
    environment.protectedResources.apiExtractionMetadata.endpoint,
    apiExtractionMetadataProtectedResources,
  );
  protectedResourceMap.set(
    environment.protectedResources.apiClauses.endpoint,
    apiClausesProtectedResources,
  );
  protectedResourceMap.set(
    environment.protectedResources.apiPlaybooks.endpoint,
    apiPlaybooksProtectedResources,
  );
  protectedResourceMap.set(
    environment.protectedResources.apiDocumentStatuses.endpoint,
    apiDocumentStatusesProtectedResources,
  );
  protectedResourceMap.set(
    environment.protectedResources.apiKeyQuestions.endpoint,
    apiKeyQuestionsProtectedResources,
  );
  protectedResourceMap.set(
    environment.protectedResources.apiLanguages.endpoint,
    apiLanguagesProtectedResources,
  );
  protectedResourceMap.set(
    environment.protectedResources.apiReporting.endpoint,
    apiReportingProtectedResources,
  );
  protectedResourceMap.set(
    environment.protectedResources.apiConfiguration.endpoint,
    apiConfigurationProtectedResources,
  );
  protectedResourceMap.set(
    environment.protectedResources.apiFileUpload.endpoint,
    apiFileUploadProtectedResources,
  );
  protectedResourceMap.set(
    environment.protectedResources.apiUsers.endpoint,
    apiUsersProtectedResources,
  );
  protectedResourceMap.set(
    environment.protectedResources.apiGroups.endpoint,
    apiGroupsProtectedResources,
  );
  protectedResourceMap.set(
    environment.protectedResources.apiAccessRoles.endpoint,
    apiAccessRolesProtectedResources,
  );
  protectedResourceMap.set(
    environment.protectedResources.apiTeamRoles.endpoint,
    apiTeamRolesProtectedResources,
  );
  protectedResourceMap.set(
    environment.protectedResources.apiPermissions.endpoint,
    apiPermissionsProtectedResources,
  );

  return protectedResourceMap;
}
